<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div v-if="page === 1" class="modal-container">
                <p v-if="!showActionsButton">
                    You have to select users that you want to preform actions with!
                </p>
                <div
                    v-if="showActionsButton === 1"
                    class="custom-control custom-switch main-switch"
                >
                    <div class="form-check form-switch">
                        <div v-if="mode === 'allUsers'">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.active_user"
                                :checked="newUserData.active_user"
                            />
                            <p>
                                {{
                                    newUserData.active_user
                                        ? 'de-activate the user: the profiles will become private'
                                        : 'activate the user: the profiles will become public'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.verified_artist"
                                :checked="newUserData.verified_artist"
                            />
                            <p>
                                {{
                                    newUserData.verified_artist
                                        ? 'un-verify artist: only the artist profile will be un-verified'
                                        : 'verify artist: only the artist profile will be verified'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.verified_venue"
                                :checked="newUserData.verified_venue"
                            />
                            <p>
                                {{
                                    newUserData.verified_venue
                                        ? 'un-verify venue: only the venue profile will be un-verified'
                                        : 'verify venue: only the venue profile will be verified'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.featured_artist"
                                :checked="newUserData.featured_artist"
                            />
                            <p>
                                {{
                                    newUserData.featured_artist
                                        ? 'un-feature artist: only the artist profile will be un-featured'
                                        : 'feature artist: only the artist profile will be featured'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.featured_venue"
                                :checked="newUserData.featured_venue"
                            />
                            <p>
                                {{
                                    newUserData.featured_venue
                                        ? 'un-feature venue: only the venue profile will be un-featured'
                                        : 'feature venue: only the venue profile will be featured'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.bid_status"
                                :checked="newUserData.bid_status"
                            />
                            <p>
                                {{
                                    newUserData.bid_status
                                        ? 'de-activate bids: it will be applied only to verified venues. If a venue is not active or not verified, then it will be automatically also be verified and activated.'
                                        : 'activate bids: it will be applied only to verified venues. If a venue is not active or not verified, then it will be automatically also be verified and activated.'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.artist_status"
                                @checked="artistStatus(newUserData.artist_status)"
                            />
                            <p>
                                {{
                                    newUserData.artist_status
                                        ? 'de-archive the artist: the artist will be de-archived'
                                        : 'archive the artist: the artist will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.venue_status"
                                @change="venueStatus(newUserData.venue_status)"
                            />
                            <p>
                                {{
                                    newUserData.venue_status
                                        ? 'de-archive the venue: the venue will be de-archived'
                                        : 'archive the venue: the venue will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.user_status"
                                @change="userStatus(newUserData.user_status)"
                            />
                            <p>
                                {{
                                    newUserData.user_status
                                        ? 'de-archive the user: the user will be de-archived'
                                        : 'archive the user: the user will be archived'
                                }}
                            </p>
                            <div
                                v-if="
                                    selectedUser &&
                                    selectedUser.length === 1 &&
                                    !selectedUser[0].is_affiliate_partner
                                "
                                class="row mb-12"
                            >
                                <p>Enter affiliate code</p>
                                <label
                                    for="affiliate_code"
                                    class="main-text-bold pb-3 pt-3 px-0"
                                    >Enter Affiliate Code</label
                                >
                                <input
                                    v-model="affiliate_code"
                                    name="affiliate_code"
                                    type="text"
                                    class="form-control main-text-input js-form-element datepicker-bid mb-1"
                                />
                                <button @click="onSubmitAffiliate">Save</button>
                            </div>
                            <div class="row mb-12">
                                <p>Prolong venue subscription to {{ resume_date }}</p>
                                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0"
                                    >Resume Date</label
                                >
                                <input
                                    v-model="resume_date"
                                    name="resume_date"
                                    type="date"
                                    id="date"
                                    required
                                    class="form-control main-text-input js-form-element datepicker-bid mb-1"
                                />
                            </div>
                        </div>
                        <div v-if="mode === 'archived'">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.artist_status"
                                @change="getArtistStatus(newUserData.artist_status)"
                            />
                            <p>
                                {{
                                    newUserData.artist_status
                                        ? 'de-archive the artist: the artist will be de-archived'
                                        : 'archive the artist: the artist will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.venue_status"
                                @change="getVenueStatus(newUserData.venue_status)"
                            />
                            <p>
                                {{
                                    newUserData.venue_status
                                        ? 'de-archive the venue: the venue will be de-archived'
                                        : 'archive the venue: the venue will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="newUserData.user_status"
                                @change="getUserStatus(newUserData.user_status)"
                            />
                            <p>
                                {{
                                    newUserData.user_status
                                        ? 'de-archive the user: the user will be de-archived'
                                        : 'archive the user: the user will be archived'
                                }}
                            </p>
                        </div>
                    </div>
                    <button @click="nextStep">Next Step</button>
                </div>
                <div
                    v-if="showActionsButton > 1"
                    class="custom-control custom-switch main-switch"
                >
                    <div class="form-check form-switch">
                        <div v-if="mode === 'allUsers'">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.active_user"
                                :checked="allUsersData.active_user"
                            />
                            <p>
                                {{
                                    allUsersData.active_user
                                        ? 'de-activate the users: the profiles will become private'
                                        : 'activate the users: the profiles will become public'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.verified_artist"
                                :checked="allUsersData.verified_artist"
                            />
                            <p>
                                {{
                                    allUsersData.verified_artist
                                        ? 'un-verify artists: only the artists profile will be un-verified'
                                        : 'verify artists: only the artists profile will be verified'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.verified_venue"
                                :checked="allUsersData.verified_venue"
                            />
                            <p>
                                {{
                                    allUsersData.verified_venue
                                        ? 'un-verify venues: only the venues profile will be un-verified'
                                        : 'verify venues: only the venues profile will be verified'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.featured_artist"
                                :checked="allUsersData.featured_artist"
                            />
                            <p>
                                {{
                                    allUsersData.featured_artist
                                        ? 'un-feature artists: only the artists profile will be un-featured'
                                        : 'feature artists: only the artists profile will be featured'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.featured_venue"
                                :checked="allUsersData.featured_venue"
                            />
                            <p>
                                {{
                                    allUsersData.featured_venue
                                        ? 'un-feature venue: only the venues profile will be un-featured'
                                        : 'feature venue: only the venues profile will be featured'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.bid_status"
                                :checked="allUsersData.bid_status"
                            />
                            <p>
                                {{
                                    allUsersData.bid_status
                                        ? 'de-activate bids: it will be applied only to verified venues. If a venue is not active or not verified, then it will be automatically also be verified and activated.'
                                        : 'activate bids: it will be applied only to verified venues. If a venue is not active or not verified, then it will be automatically also be verified and activated.'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="allUsersData.artist_status"
                                v-model="allUsersData.artist_status"
                                :checked="allUsersData.artist_status"
                            />
                            <p>
                                {{
                                    allUsersData.artist_status
                                        ? 'de-archive the artists: the artists will be de-archived'
                                        : 'archive the artists: the artists will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.venue_status"
                                :checked="allUsersData.venue_status"
                            />
                            <p>
                                {{
                                    allUsersData.venue_status
                                        ? 'de-archive the venues: the venues will be de-archived'
                                        : 'archive the venues: the venues will be archived'
                                }}
                            </p>
                            <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="allUsersData.user_status"
                                :checked="allUsersData.user_status"
                            />
                            <p>
                                {{
                                    allUsersData.user_status
                                        ? 'de-archive the users: the users will be de-archived'
                                        : 'archive the users: the users will be archived'
                                }}
                            </p>
                            <div
                                v-if="
                                    selectedUser &&
                                    selectedUser.length === 1 &&
                                    selectedUser[0].verified_venue === 1
                                "
                                class="row mb-12"
                            >
                                <p>Enter affiliate code</p>
                                <label
                                    for="affiliate_code"
                                    class="main-text-bold pb-3 pt-3 px-0"
                                    >Enter Affiliate Code</label
                                >
                                <input
                                    v-model="affiliate_code"
                                    name="affiliate_code"
                                    type="text"
                                    class="form-control main-text-input js-form-element datepicker-bid mb-1"
                                />
                            </div>
                            <div class="row mb-12">
                                <p>Prolong venue subscription to {{ resume_date }}</p>
                                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0"
                                    >Resume Date</label
                                >
                                <input
                                    v-model="resume_date"
                                    name="resume_date"
                                    type="date"
                                    id="date"
                                    required
                                    class="form-control main-text-input js-form-element datepicker-bid mb-1"
                                />
                            </div>
                        </div>
                        <div v-if="mode === 'archived'">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="allUsersArchived"
                                v-model="allUsersArchived"
                                @change="submitArchivedUsersStatus(allUsersArchived)"
                            />
                            <p>
                                {{ allUsersArchived ? 'de-archive' : 'archive' }}
                            </p>
                        </div>
                    </div>
                    <button @click="nextStep">Next Step</button>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                        <b-button class="modal-default-button" @click="closeModal">
                            Cancel
                        </b-button>
                    </slot>
                </div>
            </div>
            <div v-if="page === 2" class="modal-container w-75">
                <table v-if="showActionsButton === 1" class="table table-sm">
                    <thead>
                        <tr>
                            <th scope="col">name</th>
                            <th v-if="activeUser" scope="col">Active</th>
                            <th v-if="verifiedArtist" scope="col">Verified Artist</th>
                            <th v-if="verifiedVenue" scope="col">Verified Venue</th>
                            <th v-if="featuredArtist" scope="col">Featured Artist</th>
                            <th v-if="featuredVenue" scope="col">Featured Venue</th>
                            <th v-if="bidStatus" scope="col">Bid Active</th>
                            <th v-if="userStatus" scope="col">Archive User</th>
                            <th v-if="artistStatus" scope="col">Archive Artist</th>
                            <th v-if="venueStatus" scope="col">Archive Venue</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">{{ newUserData.full_name }}:</th>
                            <td v-if="activeUser">
                                {{
                                    newUserData.active_user
                                        ? 'user will be activated'
                                        : 'user will be de-activated'
                                }}
                            </td>
                            <td v-if="verifiedArtist">
                                {{
                                    newUserData.verified_artist
                                        ? 'user will be verified as artist'
                                        : 'user will be un-verified as artist'
                                }}
                            </td>
                            <td v-if="verifiedVenue">
                                {{
                                    newUserData.verified_venue
                                        ? 'user will be verified as venue'
                                        : 'user will be un-verify as venue'
                                }}
                            </td>
                            <td v-if="featuredArtist">
                                {{
                                    newUserData.featured_artist
                                        ? 'user will be a featured artist'
                                        : 'user will be un-feature artist'
                                }}
                            </td>
                            <td v-if="featuredVenue">
                                {{
                                    newUserData.featured_venue
                                        ? 'user will be a featured venue'
                                        : 'user will be un-feature venue'
                                }}
                            </td>
                            <td v-if="bidStatus">
                                {{
                                    newUserData.bid_status
                                        ? 'user will have activate bid'
                                        : 'de-activate bid for user'
                                }}
                            </td>
                            <td v-if="userStatus">
                                {{
                                    newUserData.user_status
                                        ? 'user will be archived'
                                        : 'user will be de-archive'
                                }}
                            </td>
                            <td v-if="artistStatus">
                                {{
                                    newUserData.artist_status
                                        ? 'user will be as archived artist'
                                        : 'user will be as de-archive artist'
                                }}
                            </td>
                            <td v-if="venueStatus">
                                {{
                                    newUserData.venue_status
                                        ? 'user will be as archive venue'
                                        : 'user will be as de-archive venue'
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="showActionsButton > 1" class="table table-sm">
                    <thead>
                        <tr>
                            <th v-if="activeUser" scope="col">Active</th>
                            <th v-if="verifiedArtist" scope="col">Verified Artist</th>
                            <th v-if="verifiedAllArtist" scope="col">Verified Artists</th>
                            allVenueStatus
                            <th v-if="verifiedVenue" scope="col">Verified Venue</th>
                            <th v-if="allVenueStatus" scope="col">Verified Venue</th>
                            <th v-if="featuredArtist" scope="col">Featured Artist</th>
                            <th v-if="featureAllArtist" scope="col">Featured Artists</th>
                            <th v-if="featuredVenue" scope="col">Featured Venue</th>
                            <th v-if="featureAllVenue" scope="col">Featured Venues</th>
                            <th v-if="bidStatus" scope="col">Bid Active</th>
                            <th v-if="bidStatusAll" scope="col">Bid Active</th>
                            <th v-if="allUserStatus" scope="col">Archive User</th>
                            <th v-if="artistStatus" scope="col">Archive Artist</th>
                            <th v-if="venueStatus" scope="col">Archive Venue</th>
                            <th v-if="allUsersArchived" scope="col">Archive User</th>
                            <th v-if="!allUsersArchived" scope="col">Archive User</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-if="activeUser">
                                {{
                                    allUsersData.active_user
                                        ? 'users will be activated'
                                        : 'users will be de-activated'
                                }}
                            </td>
                            <td v-if="verifiedArtist">
                                {{
                                    allUsersData.verified_artist
                                        ? 'users will be verified as artist'
                                        : 'users will be un-verified as artists'
                                }}
                            </td>
                            <td v-if="verifiedAllArtist">
                                {{
                                    allUsersData.verified_artist
                                        ? 'users will be verified all artists'
                                        : 'users will be un-verified all artists'
                                }}
                            </td>
                            <td v-if="verifiedVenue">
                                {{
                                    allUsersData.verified_venue
                                        ? 'users will be verified as venue'
                                        : 'users will be un-verify as venues'
                                }}
                            </td>
                            <td v-if="allVenueStatus">
                                {{
                                    allUsersData.verified_venue
                                        ? 'users will be verified as venue'
                                        : 'users will be un-verify as venues'
                                }}
                            </td>
                            <td v-if="featuredArtist">
                                {{
                                    allUsersData.featured_artist
                                        ? 'users will be a featured artist'
                                        : 'users will be un-feature artists'
                                }}
                            </td>
                            <td v-if="featureAllArtist">
                                {{
                                    allUsersData.featured_artist
                                        ? 'users will be a featured artists'
                                        : 'users will be un-feature artists'
                                }}
                            </td>
                            <td v-if="featuredVenue">
                                {{
                                    allUsersData.featured_venue
                                        ? 'users will be a featured venue'
                                        : 'users will be un-feature venues'
                                }}
                            </td>
                            <td v-if="featureAllVenue">
                                {{
                                    allUsersData.featured_venue
                                        ? 'users will be a featured venues'
                                        : 'users will be un-feature venues'
                                }}
                            </td>
                            <td v-if="bidStatus">
                                {{
                                    allUsersData.bid_status
                                        ? 'users will have activate bid'
                                        : 'de-activate bid for users'
                                }}
                            </td>
                            <td v-if="bidStatusAll">
                                {{
                                    allUsersData.bid_status
                                        ? 'users will have activate bid'
                                        : 'de-activate bid for users'
                                }}
                            </td>
                            <td v-if="allUserStatus">
                                {{
                                    allUsersData.user_status
                                        ? 'users will be archived'
                                        : 'users will be de-archive'
                                }}
                            </td>
                            <td v-if="artistStatus">
                                {{
                                    allUsersData.artist_status
                                        ? 'users will be as archived artist'
                                        : 'users will be as de-archive artists'
                                }}
                            </td>
                            <td v-if="venueStatus">
                                {{
                                    allUsersData.venue_status
                                        ? 'users will be as archive venue'
                                        : 'users will be as de-archive venues'
                                }}
                            </td>
                            <td v-if="allUsersArchived">
                                {{
                                    allUsersArchived
                                        ? 'users will be archived'
                                        : 'users will be de-archive'
                                }}
                            </td>
                            <td v-if="!allUsersArchived">
                                {{
                                    allUsersArchived
                                        ? 'users will be archived'
                                        : 'users will be de-archive'
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <slot name="footer">
                    <b-button class="modal-default-button" @click="prevStep"> Back </b-button>
                    <b-button class="modal-default-button" @click="submitData"> OK </b-button>
                </slot>
                <div class="modal-footer"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'modalActions',
        props: {
            activeModal: {
                type: Boolean
            },
            selectedUser: {
                type: Array
            },
            mode: {
                type: String
            }
        },
        data: () => ({
            page: 1,
            newUserData: {
                id: '',
                full_name: '',
                active_user: false,
                verified_artist: false,
                verified_venue: false,
                featured_artist: false,
                featured_venue: false,
                bid_status: false,
                artist_status: false,
                venue_status: false,
                user_status: false
            },
            allUsersData: {
                id: null,
                active_user: false,
                verified_artist: false,
                verified_venue: false,
                featured_artist: false,
                featured_venue: false,
                bid_status: false,
                artist_status: false,
                venue_status: false,
                user_status: false
            },
            affiliate_code: '',
            allUsersArchived: true,
            urlUserActive: '',
            urlVerifyArtist: '',
            urlVerifyVenue: '',
            urlFeaturedArtist: '',
            urlFeaturedVenue: '',
            urlBidStatus: '',
            urlArtistStatus: '',
            urlVenueStatus: '',
            urlUserStatus: '',
            urlAllUserArchive: '',
            urlAllArtistsArchive: '',
            urlAllVenuesArchive: '',
            urlAllUserActive: '',
            urlVerifyAllArtist: '',
            urlVerifyAllVenue: '',
            urlFeaturedAllVenue: '',
            urlFeaturedAllArtist: '',
            urlBidStatusAll: '',
            checked: [],
            resume_date: ''
        }),
        methods: {
            async onSubmitAffiliate() {
                if (
                    this.selectedUser[0].verified_venue &&
                    this.selectedUser[0].verified_artist
                ) {
                    return await this.onSubmitVenueAffiliate()
                } else if (this.selectedUser[0].verified_venue) {
                    return await this.onSubmitVenueAffiliate()
                } else if (this.selectedUser[0].verified_artist) {
                    return await this.onSubmitArtistAffiliate()
                } else {
                    this.closeModal()
                }
            },
            async onSubmitVenueAffiliate() {
                try {
                    await axios.post(
                        `/admin/affiliate/venue/${this.selectedUser[0].venue_id}/create-partner`,
                        {
                            code: this.affiliate_code
                        }
                    )
                    this.closeModal()
                } catch (error) {
                    console.error(error)
                }
            },
            async onSubmitArtistAffiliate() {
                try {
                    await axios.post(
                        `/admin/affiliate/artist/${this.selectedUser[0].artist_id}/create-partner`,
                        {
                            code: this.affiliate_code
                        }
                    )
                    this.closeModal()
                } catch (error) {
                    console.error(error)
                }
            },
            closeModal() {
                this.$emit('update:visible', this.activeModal)
            },
            nextStep() {
                this.page = 2
            },
            prevStep() {
                this.page = 1
            },
            submitArchivedUsersStatus(status) {
                this.allUsersArchived = status
            },
            getArtistStatus(artistStatus) {
                this.allUsersData.user_status = artistStatus
            },
            getVenueStatus(venueStatus) {
                this.allUsersData.venue_status = venueStatus
            },
            getUserStatus(userStatus) {
                this.allUsersData.user_status = userStatus
            },
            artistStatus(status) {
                this.newUserData.artist_status = status
            },
            venueStatus(status) {
                this.newUserData.venue_status = status
            },
            userStatus(status) {
                this.newUserData.user_status = status
            },
            submitDataNew() {
                if (this.activeUser) {
                    axios.put(this.urlUserActive, { active: this.newUserData.active_user })
                }
                if (this.verifiedArtist) {
                    axios.put(this.urlVerifyArtist, {
                        verified: this.newUserData.verified_artist
                    })
                }
                if (this.verifiedVenue) {
                    axios.put(this.urlVerifyVenue, {
                        verified: this.newUserData.verified_venue
                    })
                }
                if (this.featuredArtist) {
                    axios.put(this.urlFeaturedArtist, {
                        feature: this.newUserData.featured_artist
                    })
                }
                if (this.featuredVenue) {
                    axios.put(this.urlFeaturedVenue, {
                        feature: this.newUserData.featured_venue
                    })
                }
                if (this.bidStatus) {
                    axios.put(this.urlBidStatus, { bid_active: this.newUserData.bid_status })
                }

                if (this.artistStatus) {
                    this.allUsersData.artist_status || this.newUserData.artist_status
                        ? axios.put(this.urlArtistStatus, { archived_date: new Date() })
                        : axios.put(this.urlArtistStatus, { archived_date: null })
                }
                if (this.venueStatus) {
                    this.allUsersData.venue_status || this.newUserData.venue_status
                        ? axios.put(this.urlVenueStatus, { archived_date: new Date() })
                        : axios.put(this.urlVenueStatus, { archived_date: null })
                }
                if (this.userStatus) {
                    this.allUsersData.user_status || this.newUserData.user_status
                        ? axios.put(this.urlUserStatus, { archived_date: new Date() })
                        : axios.put(this.urlUserStatus, { archived_date: null })
                }
                // all users
                if (this.allUserStatus) {
                    axios.put(this.urlAllUserArchive, {
                        ids: this.allUsersData.id.join(','),
                        archived_date: new Date()
                    })
                }
                if (this.allVenueStatus) {
                    axios.put(this.urlAllVenuesArchive, {
                        ids: this.allUsersData.id.join(','),
                        archived_date: new Date()
                    })
                }
                if (this.allArtistStatus) {
                    axios.put(this.urlAllArtistsArchive, {
                        ids: this.allUsersData.id.join(','),
                        archived_date: new Date()
                    })
                }

                if (this.allActiveUser) {
                    axios.put(this.urlAllUserActive, {
                        ids: this.allUsersData.id.join(','),
                        active: true
                    })
                }
                if (this.verifiedAllArtist) {
                    axios.put(this.urlVerifyAllArtist, {
                        ids: this.allUsersData.id.join(','),
                        verified: true
                    })
                }
                if (this.verifiedAllVenue) {
                    axios.put(this.urlVerifyAllVenue, {
                        ids: this.allUsersData.id.join(','),
                        verified: true
                    })
                }
                if (this.featureAllArtist) {
                    axios.put(this.urlFeaturedAllArtist, {
                        ids: this.allUsersData.id.join(','),
                        feature: true
                    })
                }
                if (this.featureAllVenue) {
                    axios.put(this.urlFeaturedAllVenue, {
                        ids: this.allUsersData.id.join(','),
                        feature: true
                    })
                }
                if (this.bidStatusAll) {
                    axios.put(this.urlBidStatusAll, {
                        ids: this.allUsersData.id.join(','),
                        bid_active: true
                    })
                }
                //resume date
                if (this.resume_date) {
                    axios.post('/admin/subscriptions/resume', {
                        id: this.allUsersData.id[0],
                        resume_date: this.resume_date
                    })
                }
                setTimeout(function () {
                    window.location.reload()
                }, 500)
            },
            async submitData() {
                this.allUsersArchived
                    ? await this.submitDataNew()
                    : await this.submitArchivedNew()
            },
            submitArchivedNew() {
                axios.put(this.urlAllUserArchive, {
                    ids: this.allUsersData.id.join(','),
                    archived_date: null
                })
                axios.put(this.urlAllVenuesArchive, {
                    ids: this.allUsersData.id.join(','),
                    archived_date: null
                })
                axios.put(this.urlAllArtistsArchive, {
                    ids: this.allUsersData.id.join(','),
                    archived_date: null
                })
                window.location.reload()
            }
        },
        computed: {
            showActionsButton() {
                return this.selectedUser.length
            },
            activeUser() {
                if (this.newUserData.active_user !== this.selectedUser[0].active_user) {
                    return true
                }
            },
            allActiveUser() {
                if (this.allUsersData.active_user) return true
            },
            verifiedArtist() {
                if (
                    this.newUserData.verified_artist !== this.selectedUser[0].verified_artist
                ) {
                    return true
                }
            },
            verifiedVenue() {
                if (this.newUserData.verified_venue !== this.selectedUser[0].verified_venue) {
                    return true
                }
            },
            featuredArtist() {
                if (
                    this.newUserData.featured_artist !== this.selectedUser[0].featured_artist
                ) {
                    return true
                }
            },
            featuredVenue() {
                if (this.newUserData.featured_venue !== this.selectedUser[0].featured_venue) {
                    return true
                }
            },
            bidStatus() {
                if (this.newUserData.bid_status !== this.selectedUser[0].bid_status) {
                    return true
                }
            },
            artistStatus() {
                if (this.newUserData.artist_status !== this.selectedUser[0].artist_status) {
                    return true
                }
            },
            allArtistStatus() {
                if (this.allUsersData.artist_status) return true
            },
            venueStatus() {
                if (this.newUserData.venue_status !== this.selectedUser[0].venue_status) {
                    return true
                }
            },
            allVenueStatus() {
                if (this.allUsersData.venue_status) return true
            },
            userStatus() {
                if (this.newUserData.user_status !== this.selectedUser[0].user_status) {
                    return true
                }
            },
            allUserStatus() {
                if (this.allUsersData.user_status) return true
            },
            verifiedAllArtist() {
                if (this.allUsersData.verified_artist) {
                    return true
                }
            },
            verifiedAllVenue() {
                if (this.allUsersData.verified_venue) {
                    return true
                }
            },
            featureAllArtist() {
                if (this.allUsersData.featured_artist) {
                    return true
                }
            },
            featureAllVenue() {
                if (this.allUsersData.featured_venue) {
                    return true
                }
            },
            bidStatusAll() {
                if (this.allUsersData.bid_status) {
                    return true
                }
            }
        },
        created() {
            this.allUsersData.id = this.selectedUser.map((user) => user.id)
            this.page = 1
            this.newUserData.id = this.selectedUser[0].id
            this.newUserData.full_name = this.selectedUser[0].full_name
            this.newUserData.active_user = this.selectedUser[0].active_user
            this.newUserData.verified_artist = this.selectedUser[0].verified_artist
            this.newUserData.verified_venue = this.selectedUser[0].verified_venue
            this.newUserData.featured_artist = this.selectedUser[0].featured_artist
            this.newUserData.featured_venue = this.selectedUser[0].featured_venue
            this.newUserData.bid_status = this.selectedUser[0].bid_status
            this.newUserData.artist_status = this.selectedUser[0].artist_status
            this.newUserData.venue_status = this.selectedUser[0].venue_status
            this.newUserData.user_status = this.selectedUser[0].user_status
            this.urlUserActive = '/admin/user/' + this.newUserData.id + '/active'
            this.urlVerifyArtist = '/admin/user/' + this.newUserData.id + '/status/role/artist'
            this.urlVerifyVenue = '/admin/user/' + this.newUserData.id + '/status/role/venue'
            this.urlFeaturedArtist =
                '/admin/user/' + this.newUserData.id + '/feature/role/artist'
            this.urlFeaturedVenue =
                '/admin/user/' + this.newUserData.id + '/feature/role/venue'
            this.urlBidStatus = '/admin/user/' + this.newUserData.id + '/change/active/bid'
            this.urlArtistStatus =
                '/admin/user/' + this.newUserData.id + '/archived/role/artist'
            this.urlVenueStatus = '/admin/user/' + this.newUserData.id + '/archived/role/venue'
            this.urlUserStatus = '/admin/user/' + this.newUserData.id + '/archived/role/user'
            this.urlAllUserArchive = '/admin/ajax/users/archived-all/role/user'
            this.urlAllArtistsArchive = '/admin/ajax/users/archived-all/role/artist'
            this.urlAllVenuesArchive = '/admin/ajax/users/archived-all/role/venue'
            this.urlAllUserActive = '/admin/ajax/users/active-all'
            this.urlVerifyAllArtist = '/admin/ajax/users/status-all/role/artist'
            this.urlVerifyAllVenue = '/admin/ajax/users/status-all/role/venue'
            this.urlFeaturedAllArtist = '/admin/ajax/users/feature-all/role/artist'
            this.urlFeaturedAllVenue = '/admin/ajax/users/feature-all/role/venue'
            this.urlBidStatusAll = '/admin/ajax/users/change/all-active/bids'
        }
    }
    $(document).ready(function () {
        $('.modal-default-button').on('click', function () {
            setTimeout(function () {
                window.location.reload()
            }, 500)
        })
    })
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        max-height: 500px;
        overflow-y: auto;
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Instrument Sans, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
